import Date from "common/values/date/date";
import Permission from "permissions/entities/permission/permission";
import Guid from "common/values/guid/guid";
import moment from "moment";
import {Resource} from "../../resources/general";
import ResourceInfoAPIResponse from "permissions/entities/permission/api/response-contracts/resource-info-api-response";

export default class PermissionAPIResponse {
  id?: string;
  resource?: ResourceInfoAPIResponse;
  grantorUserId?: string;
  granteeUserId?: string;
  disabledDate?: string;
  createdDate?: string;
  parentId?: string;
  parentResource?: string;
  note?: string;

 async deserialize<T extends Resource>(): Promise<Permission> {
    if (this.resource === undefined) throw new Error("Permission resource not returned.");
    if (this.granteeUserId === undefined) throw new Error("Permission granteeUserId not returned.");
    if (this.grantorUserId === undefined) throw new Error("Permission grantorUserId not returned.");

    const resource = Object.assign(new ResourceInfoAPIResponse(), this.resource);
    const concreteResource = await resource.deserialize<T>();

    return new Permission(
      concreteResource,
      new Guid(this.granteeUserId),
      new Guid(this.grantorUserId, true),
      this.id ? new Guid(this.id) : undefined,
      this.parentId ? new Guid(this.parentId) : undefined,
      this.parentResource ? await Resource.fromJSON(this.parentResource) : undefined,
      this.createdDate ? new Date(moment(this.createdDate)) : undefined,
      this.disabledDate ? new Date(moment(this.disabledDate)) : undefined,
      this.note ? this.note : undefined
    );
  }
}
